'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Modal = require('./Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _RoundedButton = require('./RoundedButton');

var _RoundedButton2 = _interopRequireDefault(_RoundedButton);

var _colors = require('./styles/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalWithHeader = function ModalWithHeader(_ref) {
    var contentLabel = _ref.contentLabel,
        children = _ref.children,
        backgroundColor = _ref.backgroundColor,
        isOpen = _ref.isOpen,
        modalHeaderStyle = _ref.modalHeaderStyle,
        headerContent = _ref.headerContent,
        successFn = _ref.successFn,
        successText = _ref.successText,
        cancelFn = _ref.cancelFn,
        cancelText = _ref.cancelText,
        primaryColor = _ref.primaryColor,
        hoverColor = _ref.hoverColor,
        secondaryColor = _ref.secondaryColor,
        modalFooterStyle = _ref.modalFooterStyle,
        modalChildrenStyle = _ref.modalChildrenStyle,
        modalContentStyle = _ref.modalContentStyle,
        modalOverlayStyle = _ref.modalOverlayStyle,
        bodyOpenClassName = _ref.bodyOpenClassName,
        hoverStyle = _ref.hoverStyle,
        cancelTextHoverColor = _ref.cancelTextHoverColor,
        successButtonIsDisabled = _ref.successButtonIsDisabled,
        buttonStyle = _ref.buttonStyle;

    var headerStyle = _extends({
        position: 'relative',
        width: '100%',
        backgroundColor: _colors.onyx,
        height: 50,
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 20
    }, modalHeaderStyle);

    var footerStyle = _extends({
        padding: 20,
        paddingTop: 30
    }, modalFooterStyle);

    var childrenStyle = _extends({
        margin: '25px 20px 0px'
    }, modalChildrenStyle);

    return _react2.default.createElement(
        'div',
        { id: contentLabel },
        _react2.default.createElement(
            _Modal2.default,
            {
                isOpen: isOpen,
                onRequestClose: cancelFn,
                contentLabel: contentLabel,
                style: {
                    overlay: _extends({}, modalOverlayStyle),
                    content: _extends({
                        backgroundColor: backgroundColor,
                        padding: 0,
                        width: 'auto'
                    }, modalContentStyle)
                },
                hoverStyle: _extends({
                    backgroundColor: _colors.graphite
                }, hoverStyle),
                bodyOpenClassName: bodyOpenClassName
            },
            _react2.default.createElement(
                'div',
                { style: headerStyle },
                headerContent
            ),
            _react2.default.createElement(
                'div',
                { style: childrenStyle },
                children
            ),
            _react2.default.createElement(
                'div',
                { style: footerStyle },
                _react2.default.createElement(
                    _RoundedButton2.default,
                    {
                        type: 'primary',
                        onClick: successFn,
                        primaryColor: primaryColor,
                        hoverColor: hoverColor,
                        isDisabled: successButtonIsDisabled,
                        style: buttonStyle
                    },
                    successText
                ),
                cancelText && _react2.default.createElement(
                    _RoundedButton2.default,
                    {
                        type: 'cancel',
                        onClick: cancelFn,
                        primaryColor: secondaryColor,
                        hoverColor: cancelTextHoverColor,
                        style: { cursor: 'pointer' }
                    },
                    cancelText
                )
            )
        )
    );
};

ModalWithHeader.propTypes = {
    children: _propTypes2.default.element,
    contentLabel: _propTypes2.default.string.isRequired,
    backgroundColor: _propTypes2.default.string.isRequired,
    modalHeaderStyle: _propTypes2.default.object,
    successFn: _propTypes2.default.func.isRequired,
    successText: _propTypes2.default.string.isRequired,
    cancelFn: _propTypes2.default.func,
    cancelText: _propTypes2.default.string,
    primaryColor: _propTypes2.default.string.isRequired,
    hoverColor: _propTypes2.default.string.isRequired,
    secondaryColor: _propTypes2.default.string.isRequired,
    modalFooterStyle: _propTypes2.default.object,
    modalChildrenStyle: _propTypes2.default.object,
    modalContentStyle: _propTypes2.default.object,
    modalOverlayStyle: _propTypes2.default.object,
    bodyOpenClassName: _propTypes2.default.string,
    hoverStyle: _propTypes2.default.object,
    cancelTextHoverColor: _propTypes2.default.string,
    isOpen: _propTypes2.default.bool.isRequired
};

ModalWithHeader.defaultProps = {
    contentLabel: '',
    backgroundColor: _colors.graphite,
    successFn: function successFn() {
        return console.log('modalSuccessFn prop is required');
    },
    successText: '',
    primaryColor: _colors.purple,
    hoverColor: _colors.orchid,
    secondaryColor: 'white',
    cancelTextHoverColor: 'white',
    isOpen: false
};

exports.default = ModalWithHeader;
//# sourceMappingURL=ModalWithHeader.js.map